import type { DataItem } from '../../../../utils/interface-types';

export const FILE_UPLOAD_MESSAGE_MARKER = 'File Name:';

export function isFileUploadHumanMessage(message: DataItem): boolean {
  return (
    message.role === 'Human' &&
    typeof message.message === 'string' &&
    message.message.includes(FILE_UPLOAD_MESSAGE_MARKER)
  );
}

export function findLatestFileUploadMessageIndex(chatHistory: DataItem[]): number {
  for (let i = chatHistory.length - 1; i >= 0; i -= 1) {
    if (isFileUploadHumanMessage(chatHistory[i])) {
      return i;
    }
  }
  return -1;
}

export function hasUploadingFileMessage(
  chatHistory: DataItem[],
  isFileUploadPending: boolean | undefined,
): boolean {
  return Boolean(isFileUploadPending) && chatHistory.some(isFileUploadHumanMessage);
}

export function buildFileUploadMessageText(
  fileName: string,
  fileSize: string,
  queryText?: string,
): string {
  const fileLine = `${FILE_UPLOAD_MESSAGE_MARKER} ${fileName}\n${fileSize}`;
  return queryText?.trim() ? `${queryText.trim()}\n\n${fileLine}` : fileLine;
}
